/* src/app/order/components/order-pricing/pricing-adjustments/direct-price-adjustments/direct-price-adjustments.style.scss */
.fees-mode-checkbox {
  margin: 15px 0 0 0;
}
.label {
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: #007d40;
}
.direct-price-adjustments {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 10px 0 0 0;
}
.direct-price-adjustments .direct-price-adjustment,
.direct-price-adjustments .new-daily-rate {
  flex-basis: 48%;
  margin-bottom: 20px;
}
.direct-price-adjustments .direct-price-adjustment .direct-price-adjustment-label,
.direct-price-adjustments .new-daily-rate .direct-price-adjustment-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.direct-price-adjustments .direct-price-adjustment .direct-price-adjustment-label .hint,
.direct-price-adjustments .new-daily-rate .direct-price-adjustment-label .hint {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  color: #8C8C8C;
}
.direct-price-adjustments .direct-price-adjustment .price,
.direct-price-adjustments .new-daily-rate .price {
  display: flex;
  align-items: center;
  height: 40px;
  font-weight: bold;
  font-size: 15px;
  line-height: 24px;
}
/*# sourceMappingURL=direct-price-adjustments.style.css.map */
